import { axiosIns } from "../utils";

export const fetchUserCategories = async () => {
  const res = await axiosIns.get("/user-categories/");
  return res && res.data ? res.data : res;
};

export const fetchUserCategoryById = async (id) => {
  if (!id) return null;
  const res = await axiosIns.get(`/user-categories/${id}/`);
  return res && res.data ? res.data : res;
};

export const createUserCategory = async (payload) => {
  const res = await axiosIns.post("/user-categories/", payload);
  return res && res.data ? res.data : res;
};

export const updateUserCategory = async (id, payload) => {
  const res = await axiosIns.patch(`/user-categories/${id}/`, payload);
  return res && res.data ? res.data : res;
};

export const deleteUserCategory = async (id) => {
  const res = await axiosIns.delete(`/user-categories/${id}/`);
  return res;
};

/**
 * Institutions (subcategories). Pass `categoryId` to only list the ones
 * belonging to a given institution category.
 */
export const fetchUserSubcategories = async (categoryId) => {
  const res = await axiosIns.get("/user-subcategories/", {
    params: categoryId ? { category_id: categoryId } : undefined,
  });
  return res && res.data ? res.data : res;
};

export const fetchUserSubcategoryById = async (id) => {
  if (!id) return null;
  const res = await axiosIns.get(`/user-subcategories/${id}/`);
  return res && res.data ? res.data : res;
};

export const createUserSubcategory = async (payload) => {
  const res = await axiosIns.post("/user-subcategories/", payload);
  return res && res.data ? res.data : res;
};

export const updateUserSubcategory = async (id, payload) => {
  const res = await axiosIns.patch(`/user-subcategories/${id}/`, payload);
  return res && res.data ? res.data : res;
};

export const deleteUserSubcategory = async (id) => {
  const res = await axiosIns.delete(`/user-subcategories/${id}/`);
  return res;
};

export const fetchUserTypes = async () => {
  const res = await axiosIns.get("/user-types/");
  return res && res.data ? res.data : res;
};
